import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Ruler: FC<IconSvgProps> = ({ color, clss, width = 24, height = 24 }) => {
    const styles = {
        svg: {
            verticalAlign: 'middle',
            overflow: 'hidden',
            // Outline icon: inline so stylesheet rules like `svg { fill: currentColor }` (mobile menu) can't fill it.
            fill: 'none',
        },
    };

    return (
        <svg
            style={{ ...styles.svg }}
            className={clss}
            width={width}
            height={height}
            viewBox="0 0 24 24"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M10 15v-3" />
            <path d="M14 15v-3" />
            <path d="M18 15v-3" />
            <path d="M2 8V4" />
            <path d="M22 6H2" />
            <path d="M22 8V4" />
            <path d="M6 15v-3" />
            <rect x="2" y="12" width="20" height="8" rx="2" />
        </svg>
    );
};

export default Ruler;
